import React, { useState } from "react";
import LeftArrowIcon from "../assets/icons/Prevarrow.png";
import RightArrowIcon from "../assets/icons/Nextarrow.png";
import BlogPost_DueDiligence_1 from "../assets/icons/BlogPost_DueDiligence.png";
import BlogPost_DueDiligence_2 from "../assets/icons/blog2.png";
import BlogPost_DueDiligence_3 from "../assets/icons/blog3.png";
import BlogPost_DueDiligence_4 from "../assets/icons/blog4.png";

import BlogPost_InstantCheck_1 from "../assets/icons/BlogImage.png";
import BlogPost_InstantCheck_2 from "../assets/icons/blog2.png";
import BlogPost_InstantCheck_3 from "../assets/icons/blog3.png";
import BlogPost_InstantCheck_4 from "../assets/icons/blog4.png";

import BlogPost_BackgroundCheck_1 from "../assets/icons/BlogImage.png";
import BlogPost_BackgroundCheck_2 from "../assets/icons/blog2.png";
import BlogPost_BackgroundCheck_3 from "../assets/icons/blog3.png";
import BlogPost_BackgroundCheck_4 from "../assets/icons/blog4.png";


import { BlogCard, BlogContainer, BlogGrid, BlogImage, BlogSectionArrowButton, BlogSectionArrowWrapper, BlogSectionMobileSlider, BlogSectionTitle, BlogText } from "../assets/styles/CommonStyles";
import Modal from "../modal/BlogForm"; 
import { useLocation } from "react-router-dom";



const NextArrow = ({ onClick }) => (
  <BlogSectionArrowButton src={RightArrowIcon} alt="Next" onClick={onClick} style={{ right: "-6vw" }} />
);

const PrevArrow = ({ onClick }) => (
  <BlogSectionArrowButton src={LeftArrowIcon} alt="Prev" onClick={onClick} style={{ left: "-6vw" }} />
);

const BlogSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const location = useLocation();

  const isInstantChecks = location.pathname.includes("instant-checks");
  const isBackgroundChecks = location.pathname.includes("background-checks");
  const isDueDiligence = location.pathname.includes("due-diligence");

  const blogPosts = isInstantChecks
    ? [
        { image: BlogPost_InstantCheck_1, text: "Dummy Copy for instant check" },
        { image: BlogPost_InstantCheck_2, text: "Dummy Copy for instant check" },
        { image: BlogPost_InstantCheck_3, text: "Dummy Copy for instant check" },
        { image: BlogPost_InstantCheck_4, text: "Dummy Copy for instant check" },
      ]
    : isBackgroundChecks
    ? [
        { image: BlogPost_BackgroundCheck_1, text: "Dummy Copy for background check" },
        { image: BlogPost_BackgroundCheck_2, text: "Dummy Copy for background check" },
        { image: BlogPost_BackgroundCheck_3, text: "Dummy Copy for background check" },
        { image: BlogPost_BackgroundCheck_4, text: "Dummy Copy for background check" },
      ]
    : isDueDiligence
    ? [
        { image: BlogPost_DueDiligence_1, text: "<strong>Why Due Diligence is Crucial:</strong> The Ultimate Guide to Smart Decision-Making" },
        { image: BlogPost_DueDiligence_2, text: "Dummy Copy for due diligence" },
        { image: BlogPost_DueDiligence_3, text: "Dummy Copy for due diligence" },
        { image: BlogPost_DueDiligence_4, text: "Dummy Copy for due diligence" },
      ]
    : []; 


  const openModal = (post) => {
    setSelectedPost(post);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPost(null);
  };
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <BlogContainer>
      <BlogSectionTitle>Popular blog posts</BlogSectionTitle>
      {/* Desktop Grid */}
      <BlogGrid>
        {blogPosts.map((post, index) => (
          <BlogCard key={index} onClick={() => openModal(post)}>
            <BlogImage src={post.image} alt={`Blog ${index + 1}`} />
            <BlogText dangerouslySetInnerHTML={{ __html: post.text }}/>
          </BlogCard>
        ))}
      </BlogGrid>
      {/* Mobile Slider */}
      <BlogSectionMobileSlider {...settings}>
        {blogPosts.map((post, index) => (
          <BlogSectionArrowWrapper key={index}>
            <BlogCard onClick={() => openModal(post)}>
              <BlogImage src={post.image} alt={`Blog ${index + 1}`} />
              <BlogText dangerouslySetInnerHTML={{ __html: post.text }}/>
            </BlogCard>
          </BlogSectionArrowWrapper>
        ))}
      </BlogSectionMobileSlider>
      <Modal isOpen={isModalOpen} post={selectedPost} onClose={closeModal} />

    </BlogContainer>
  );
};

export default BlogSection;
